import React from 'react'
import './Login.css'
import { auth } from './firebase'
import { provider } from './firebase'
import { signInWithPopup } from 'firebase/auth'

function Login() {
    const signIn = () => {
        signInWithPopup(auth, provider).catch((error) => alert(error.message));
    }
  return (
    <div className='login'>
      <h1>Welcome to Logan's Messaging App</h1>
        <h2>Login to Your Account</h2>
        <div className='login__logo'>

        </div>
        <button onClick={signIn}>Sign In with Google</button>

    </div>
  )
}

export default Login